<template>
  <VanPopup
    v-model:show="modalStore.showReceivedModal"
    class="modal-swap-received text-primary-content"
    overlay-class="modal-swap-received-overlay"
    @click="close"
  >
    <div class="flex flex-col items-center gap-5">
      <!-- <img
        src="/img/payment-success-girl.jpg"
        class="w-[222px] rounded-lg"
        alt=""
      /> -->

      <span class="text-xl text-white">您已获得</span>

      <p v-if="modalStore.receiveType === 'CrystalOrderPay'" class="text-xl">
        {{ $t(`Payment.success`) }}
      </p>
      <p
        v-else-if="modalStore.receiveType === 'Subscription'"
        class="text-center px-10"
        v-html="$t(`Payment.subscribed`, { type: membershipText })"
      />

      <div
        class="flex justify-center gap-2.5"
        v-if="modalStore.receiveList.length && modalStore.receiveList[0].type"
      >
        <div
          class="p-3 rounded-md items-center gap-3 btn w-full h-full btn-xs"
          v-for="(item, idx) in modalStore.receiveList"
          :key="idx"
        >
          <img class="h-6 object-contain" :src="typeMap[item.type!]" alt="" />
          <span class="text-lg">{{ item.amount }}</span>
        </div>
      </div>

      <!-- <div
        class="flex gap-2.5"
        v-if="modalStore.receiveType === 'CrystalOrderPay'"
      >
        <button
          class="btn btn-ghost  btn-sm"
          @click="$router.push({ name: 'chatList' }), close()"
        >
          {{ $t(`Payment.chatList`) }}
        </button>
        <button
          class="btn btn-primary btn-sm"
          v-if="modalStore.receiveList[0].type === 'crystal'"
          @click="
            $router.push({ name: 'imageGenerateList', hash: '#toMark' }),
              close()
          "
        >
          {{ $t(`Payment.unlockImage`) }}
        </button>
      </div> -->
      <p class="pt-10 text-white">
        {{ $t(`Message.tapToClose`) }}
      </p>
    </div>
  </VanPopup>
</template>

<script setup lang="ts">
import { useGlobalModal } from "@/stores/globalModal";
import { useGlobalUser } from "@/stores/globalUser";
import { ReceivedType } from "@/types/payment";
import { useCrystalUrl, usePowerUrl } from "@/use/common";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const modalStore = useGlobalModal();
const userStore = useGlobalUser();
const typeMap: Record<ReceivedType, string> = {
  powerCube: usePowerUrl(),
  crystal: useCrystalUrl(),
};

const { t } = useI18n();
const close = () => {
  modalStore.showReceivedModal = false;
};

const subscriptionType = computed(() => userStore.user.subscriptionType);
const isTrial = computed(
  () =>
    userStore.user.dtSubscriptionTrialEnd &&
    new Date(userStore.user.dtSubscriptionTrialEnd) > new Date()
);

const membershipText = computed(() => {
  let activeType = subscriptionType.value;
  if (isTrial.value && activeType < 3) return t(`purchase.sub.trial`);
  return t(`purchase.sub.${activeType}.title`);
});
</script>

<style scoped>
.modal-swap-received {
  background: transparent;
}

.modal-swap-received-overlay {
  background-color: rgba(0, 0, 0, 0.5);
  /* 高斯模糊 */
  backdrop-filter: blur(10px);
}
</style>
